createGiftModel